import React, { useContext } from 'react'

import SectionThemeContext from '@contexts/SectionTheme'

import { Swiper } from 'swiper/react'
import { Navigation, Scrollbar, A11y } from 'swiper'

import useSwiperRef from '@hooks/useSwiperRef'

import * as S from './styles'
import { ButtonForwardingRef } from '@/atoms/Button'

const BaseCarousel = ({ children, swiperProps, theme }) => {
  const colorScheme = useContext(SectionThemeContext) || theme

  const [nextEl, nextElRef] = useSwiperRef()
  const [prevEl, prevElRef] = useSwiperRef()
  const [scrollbarEl, scrollbarElRef] = useSwiperRef()

  return (
    <Swiper
      modules={[Navigation, Scrollbar, A11y]}
      spaceBetween={24}
      slidesPerView={'auto'}
      navigation={{
        prevEl,
        nextEl,
      }}
      scrollbar={{ el: scrollbarEl }}
      a11y={{
        prevSlideMessage: 'Precedente card',
        nextSlideMessage: 'Prossima card',
      }}
      {...swiperProps}
    >
      {children}
      <S.Nav>
        <ButtonForwardingRef
          ref={prevElRef}
          iconEnd={'arrow-left-big'}
          primary
          inheritedColorScheme={colorScheme}
          ariaLabel="Slide precedente"
        />
        <S.NavScrollbar ref={scrollbarElRef} />
        <ButtonForwardingRef
          ref={nextElRef}
          iconEnd={'arrow-right-big'}
          primary
          inheritedColorScheme={colorScheme}
          ariaLabel="Slide successiva"
        />
      </S.Nav>
    </Swiper>
  )
}

export default BaseCarousel
